export const UPDATE_INITIAL_VALUES = 'newReport/UPDATE_INITIAL_VALUES'
export const UPDATE_FORM_CONFIG = 'newReport/UPDATE_FORM_CONFIG'
export const UPDATE_USER_DETAILS = 'newReport/UPDATE_USER_DETAILS'
export const RESET = 'newReport/RESET'
export const RESET_INITIAL_VALUES = 'newReport/RESET_INITIAL_VALUES'
